import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { httpRequest } from 'utils/httpRequest';
import { SelectPicker } from 'rsuite';
import { Pagination } from 'rsuite';
import 'rsuite/dist/rsuite.min.css';
import CircleLoader from "components/loader/CircleLoader"
import { useLoader } from 'components/loader/useLoader';

const ContactSupport = () => {

    const { loading, startLoading, stopLoading } = useLoader()

    const [contactSupportData, setContactSupportData] = useState([])
    const [selectedFilter, setSelectedFilter] = useState(null)
    const [activePage, setActivePage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [total, setTotal] = useState(0);



    // Sample data - you can replace this with your dynamic data
    const [data, setData] = useState([
        { id: 1, name: 'ABD Villiers', description: 'This is Dummy description', },
        { id: 2, name: 'Boeta Dippenar', description: 'This is Dummy description', },
        { id: 3, name: 'Greame Smith', description: 'This is Dummy description', },
        { id: 4, name: 'Herschell Gibbs', description: 'This is Dummy description', },
        { id: 5, name: 'Jacques Kallis', description: 'This is Dummy description', },
        { id: 6, name: 'M Ntini', description: 'This is Dummy description', },
        { id: 7, name: 'jack Rudolph', description: 'This is Dummy description', },
    ]);

    const selectData = [
        { label: 'Replied', value: true },
        { label: 'Not Replied', value: false },

    ];

    const handlePageChange = (page) => {
        setActivePage(page);
        getContactSupportData(page, limit);
    };


    const navigate = useNavigate();

    const handleEdit = (id) => {
        navigate(`/admin/reply-contact-support/${id}`)
    }











    const getContactSupportData = async (page = 1, limit = 10) => {

        startLoading()
        try {
            const response = await httpRequest(
                "contact/getContactUsMessages",
                "GET",
                {},
                {
                    isReplied: selectedFilter,
                    page: page,
                    limit: limit
                },
                true,
                false
            );

            if (response.code === 200) {
                
                setContactSupportData(response?.data)
                setTotal(response?.total);
                setActivePage(response?.page);
                setLimit(response?.limit);
            }
        } catch (error) {
            console.error("Error while navigating:", error);
        }finally{
            stopLoading()
        }
    }


    useEffect(() => {
        getContactSupportData(activePage,limit)
    }, [selectedFilter])

    const handleFilterChange = (value) => {
        setSelectedFilter(value)

    }


    return (
        <>


        {loading ? <CircleLoader/> :(   <div className="container-fluid py-4 mt-5">
                <div className="row">
                    <div className="col">
                        <div className="card shadow">
                            {/* Card Header */}
                            <div className="card-header border-0 d-flex justify-content-end">
                                <h3 className="mb-0 mr-auto">Contact Support</h3>
                                <SelectPicker
                                    data={selectData}
                                    placeholder="filter"
                                    style={{ width: 224 }}
                                    onChange={handleFilterChange}
                                    searchable={false}
                                    value={selectedFilter}
                                />
                            </div>

                            {/* Table */}
                            <div className="table-responsive">
                                <table className="table align-items-center table-flush">
                                    <thead className="thead-light">
                                        <tr>
                                            <th scope="col">S.No</th>
                                            <th scope="col">Email</th>
                                            <th scope="col">Description</th>
                                            <th scope="col">Action</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {contactSupportData && contactSupportData.length > 0 && contactSupportData.map((item, index) => (
                                            <tr key={item._id}>

                                                <td>
                                                    <span className="mb-0 text-sm font-weight-bold">
                                                        {index + 1}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span className="mb-0 text-sm font-weight-bold">
                                                        {item?.email}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span className="text-muted">
                                                        {item?.description}
                                                    </span>
                                                </td>

                                                <td>
                                                    {item?.isReplied ? (<button
                                                        className="btn btn-danger btn-sm"
                                                        onClick={() => handleEdit(item.id, item.name)}
                                                        title="Already Replied"
                                                        disabled={true}
                                                    >
                                                        <i
                                                            className="fas fa-arrow-right mx-2"
                                                            style={{
                                                                transform: "rotate(200deg)",
                                                                transformOrigin: "center",
                                                            }}></i> {/* Forwarding arrow */}
                                                    </button>) : (<button
                                                        className="btn btn-danger btn-sm"
                                                        onClick={() => handleEdit(item._id)}
                                                        title="Reply"
                                                    >
                                                        <i
                                                            className="fas fa-arrow-right mx-2"
                                                            style={{
                                                                transform: "rotate(200deg)",
                                                                transformOrigin: "center",
                                                            }}></i> {/* Forwarding arrow */}
                                                    </button>)}
                                                </td>

                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            {/* Card Footer with Pagination */}
                            <div className="card-footer py-4">
                                <div className="d-flex justify-content-end">
                                    <Pagination
                                        size="sm"
                                        total={total}
                                        limit={limit}
                                        activePage={activePage}
                                        onChangePage={handlePageChange}
                                        maxButtons={5}
                                        prev
                                        next
                                        last
                                        first
                                        ellipsis
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>)}



        </>
    );
};

export default ContactSupport;